<template>
  <div class="pcb-qty-picker">
    <button :disabled="qty <= 0" class="pcb-qty-picker__action less" @click.prevent="decrease" aria-label="Decrease Quantity"></button>
    <div class="pcb-qty-picker__input">
      <label :for="'pcb-qty-picker-field-' + randomLabelNumber" class="sr-only">Quantity</label>
      <input class="pcb-qty-picker__input-field" :id="'pcb-qty-picker-field-' + randomLabelNumber" type="number" v-model="qty" v-on:keypress="isNumber($event)" min="0" :max="max" readonly>
    </div>
    <button :disabled="qty == max" class="pcb-qty-picker__action" @click.prevent="increase" aria-label="Increase Quantity"></button>
  </div>
</template>
<script>
export default {
  props: [
    'quantity',
    'max'
  ],
  data: function () {
    return {
      randomLabelNumber: Math.floor(Math.random() * (1000)) + 1
    }
  },
  computed: {
    qty: {
      set (newQty) {
        const value = Number(newQty)
        if (isNaN(value) || value < 0) {
          return this.$emit('change', 0)
        }
        if (value > this.max) return this.$emit('change', this.max)
        return this.$emit('change', value)
      },
      get () {
        return this.quantity
      }
    }
  },
  methods: {
    isNumber: function($event) {
      let evt = (event) ? event : window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    increase () {
      if (this.quantity === this.max) return null
      this.$emit('change', this.quantity + 1)
    },
    decrease () {
      if (this.quantity == 0) return 0
      this.$emit('change', this.quantity - 1)
    }
  }
}
</script>
